export default "__VITE_ASSET__BJZmVGkn__"